module.exports = __webpack_public_path__ + "static/media/builtinv2-datchiki 3.2ca4f63d.png";